export default "__VITE_ASSET__3EsNUMHy__"